// ##### 23-07-28 Krat-Komarov
import parse from 'html-react-parser';
// ##### Komarov 2025-07-24
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';

// ##### 23-09-14 Komarov
// import './AboutUsCSS.css'

// ##### Komarov 2025-07-24
const AboutUs = () => {
  // ##### Komarov 2025-07-28
  const language = useSelector(state => state.language);
  const pages = useSelector(state => state.pages.loadedpages);
  // ##### Komarov 2025-07-24: Исправил ошибку при обновлении вкладки страницей About Us, на которую переходим с футера (с id 1)
  const page = pages[2]?.[language] || pages[1]?.[language];

  return (
    // ##### 25-01-09 Komarov
    <div
      key={uniqueId()}
      className="purecontentPage"
      data-component="AboutUsSsr"
    >
      <h2 key={uniqueId()}>
        {page
          .filter(pageItem => pageItem.content_name === 'Title')
          .map(foundPage => {
            return parse(foundPage.text);
          })}
      </h2>
      <div key={uniqueId()} className="WrapperAboutUs">
        {page
          .filter(pageItem => pageItem.content_name === 'Body')
          .map(foundPage => {
            // return <li key={() => uniqueId()}>{parse(foundPage.text)}</li>;
            return (
              <React.Fragment key={uniqueId()}>
                {parse(foundPage.text)}
              </React.Fragment>
            );
          })}
      </div>
    </div>
  );
};

export default AboutUs;
